import { display } from '../lib/fonts';

// Full-screen loading state shown while a page checks the session.
// Kept under the old name so existing imports keep working.
const RocketLoader = () => {
    return (
        <div
            className="fixed inset-0 z-50 flex flex-col items-center justify-center gap-5 bg-white dark:bg-gray-950"
            role="status"
            aria-live="polite"
        >
            <span className={`${display.className} text-2xl font-extrabold tracking-tight text-slate-900 dark:text-white`}>
                Doogler<span className="text-customBlue">.</span>
            </span>
            <span className="h-8 w-8 animate-spin rounded-full border-[3px] border-customBlue/25 border-t-customBlue" />
            <span className="sr-only">Loading</span>
        </div>
    );
};

export default RocketLoader;
